<span class="section-pill-wrapper" *ngIf="sectionId">
  <a #pillLink
     class="section-pill"
     [href]="profileUrl"
     target="_blank"
     (mouseenter)="onPillEnter()"
     (mouseleave)="onPillLeave()">
    {{ pillLabel }}
  </a>
</span>
